import {ModuleFederationRuntimePlugin} from '@module-federation/runtime';
import {RemoteWithEntry} from '@module-federation/sdk';
import {GENERICERROR} from '@manual_encounters/constants/BannerMessages';

export default function (): ModuleFederationRuntimePlugin {
  return {
    name: 'mf-plugin-fallback',
    async errorLoadRemote({ id, origin, lifecycle }) {
      // Fallback: generate a minimal manifest.json when remote is unavailable
      if (lifecycle === 'afterResolve') {
        const path = new URL(id).origin;
        const remote = origin.options.remotes
          .filter((remote): remote is RemoteWithEntry => 'entry' in remote)
          .find((remote) => remote.entry === id);

        return {
          id: remote?.name,
          name: remote?.name,
          metaData: {
            type: 'app',
            name: remote?.name,
            buildInfo: {
              buildVersion: '1.0.0',
              buildName: remote?.name,
            },
            remoteEntry: {
              type: 'module',
              name: 'remoteEntry.js'
            },
            globalName: remote?.name,
            publicPath: `${path}/`,
          },
          shared: [],
          remotes: [],
          exposes: [],
        };
      }

      // Fallback: render a Banner with message when remote component is unavailable
      if (lifecycle === 'onLoad') {
        const { createElement, Fragment } = await import('react');
        const { default: Banner, BannerTypes } = await import('patient-ping-remedy/packages/banner');
        const { globalStyles } = await import('@/styles');

        return () => createElement(Fragment, {
          children: [
            createElement('style', {
              key: 'style',
              children: [globalStyles.styles],
            }),
            createElement(Banner, {
              key: 'banner',
              type: BannerTypes.PATIENT_SAFETY,
              children: `Failed to load remote module. ${GENERICERROR}`,
            }),
          ],
        });
      }
    },
  };
}
